import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Textfit } from 'react-textfit';

import useComponentSize from '../../../../../../hooks/useComponentSize';
import { getCardElementTextFontFamily, googleFontInfo } from './helpers';
import GoogleFontLoader from '../../../../../../services/cards/components/CardElementText/GoogleFontLoader';

const propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  element: PropTypes.shape({
    cardElement: PropTypes.object.isRequired,
    cardElementConfiguration: PropTypes.object.isRequired,
  }).isRequired,
  onElementConfigurationChange: PropTypes.func.isRequired,
};

const CardDesignerCardElementText = ({
  className,
  onClick,
  element,
  onElementConfigurationChange,
}) => {
  const classes = classNames({
    'card-designer-card-element': true,
    'card-designer-card-element-text': true,
    [className]: !!className,
  });
  const { cardElementConfiguration } = element;
  const {
    text,
    help_placeholder: helpPlaceholder,
    font_family: fontFamily,
  } = cardElementConfiguration;
  const ref = useRef(null);
  const { width, height } = useComponentSize(ref);
  const googleFontDetails = googleFontInfo.find(x => x.font === fontFamily);

  return (
    <Fragment>
      {googleFontDetails && <GoogleFontLoader fontFamily={fontFamily} />}
      {}
      <div
        ref={ref}
        className={classes}
        onClick={() => {
          onClick();
        }}
        style={{
          zIndex: 10,
          fontFamily: getCardElementTextFontFamily(cardElementConfiguration),
          color: cardElementConfiguration.font_color,
          fontWeight: cardElementConfiguration.font_weight ?? 'normal',
          fontStyle: cardElementConfiguration.font_style ?? 'normal',
          textAlign:
            cardElementConfiguration.text_align?.toLowerCase?.() ?? undefined,
          textTransform:
            cardElementConfiguration.text_transform?.toLowerCase?.() ??
            undefined,
        }}
      >
        <Textfit
          className="text-fit"
          // Force rerender and fitting every time the text, font family and dimensions change
          key={`${width * height}-${
            cardElementConfiguration.font_family
          }-${text}`}
          mode="multi"
          max={9999}
        >
          <div
            contentEditable
            suppressContentEditableWarning
            placeholder="Type something..."
            className="card-designer-card-element-text-editable"
            onBlur={event => {
              const { textContent } = event.target;

              onElementConfigurationChange({
                element,
                elementConfig: {
                  text: textContent,
                },
              });
            }}
          >
            {text ?? helpPlaceholder}
          </div>
        </Textfit>
      </div>
    </Fragment>
  );
};

CardDesignerCardElementText.propTypes = propTypes;

export default CardDesignerCardElementText;
